import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { ITheme } from "@fluentui/react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import { DirectionalHint, Tooltip } from "@fluentui/react";

import { getWindowBoundsFunction } from "@1js/acui-common";
import { AppContext } from "@1js/acui-context";
import { platformFeatures } from "@1js/acui-experiments";
import { AppThemeConsumer } from "@1js/acui-theme";

import type { AppTooltipProps } from "./AppTooltip.Props";
import { getStyles } from "./AppTooltip.styles";

export class AppTooltip extends React.PureComponent<AppTooltipProps, {}> {
  declare context: React.ContextType<typeof AppContext>;

  public render() {
    const { content } = this.props;
    const resolvedContent = typeof content === "function" ? content() : content;
    const tooltipForMacIsEnabled = this.context.isPlatformFeatureEnabled?.(
      platformFeatures.tooltipForMacIsEnabled
    );
    const isBeakVisible = tooltipForMacIsEnabled
      ? { isBeakVisible: false }
      : {};
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <Tooltip
            calloutProps={{
              ...isBeakVisible,
              styles: getStyles(
                theme,
                this.props.hidden,
                this.props.delayTooltip,
                tooltipForMacIsEnabled
              ),
              beakWidth: 10,
              bounds: getWindowBoundsFunction(this.context.appWindow),
              gapSpace: this.props.topMargin,
              id: "Callout-" + this.props.id,
            }}
            directionalHint={
              this.props.directionalHint
                ? this.props.directionalHint
                : DirectionalHint.bottomCenter
            }
            directionalHintForRTL={this.props.directionalHintForRTL}
            content={resolvedContent}
            targetElement={this.props.targetElement}
            onMouseEnter={this.props.mouseEnterCallback}
            onMouseLeave={this.props.mouseLeaveCallback}
            id={this.props.id}
          />
        )}
      </AppThemeConsumer>
    );
  }
}

AppTooltip.contextType = AppContext;
